import { Grid, Button, Chip, Box, Typography, useTheme } from '@mui/material';
import { Modal } from '@care/react-component-lib';
import { ModalMemberSelectionCoreProps } from '@/types';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import { LAYOUTS } from '@/constants';

function GreaterCareModalMemberSelection({
  handleDTSeeker,
  handleDTSitter,
  handleModalOnClose,
  handleSeniorCareSitter,
  isModalOpen,
  modalButtonsText,
  selectedVerticalIcon,
  seniorCareIndividualSmb,
  seniorCareSteps,
}: ModalMemberSelectionCoreProps) {
  const theme = useTheme();
  return (
    <Modal
      onClose={() => {
        AnalyticsHelper.logEvent({
          name: AnalyticsEventName.CTA_INTERACTED,
          data: {
            cta_intent: 'Dismiss modal',
            cta_text: CtaText.CLOSE_MODAL,
            cta_location: CtaLocation.VHP_MODAL,
            screen_name: ScreenName.VISITOR_HOMEPAGE,
            enrollment_initiated: false,
          },
        });
        handleModalOnClose();
      }}
      open={isModalOpen}
      maxWidth="xs"
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '475px',
        },
        '& .MuiDialogContent-root': {
          width: '344px',
          margin: '0 auto',
          padding: 0,
        },
      }}>
      <Box data-testid={`${LAYOUTS.greaterCare}-for-modal`}>{selectedVerticalIcon}</Box>
      <Typography variant="h2" marginTop={seniorCareSteps ? '0px' : '6px'}>
        {seniorCareSteps ? 'Are you an individual or small business?' : 'I would like to:'}
      </Typography>
      <Box sx={{ mt: '26px', mb: '21px' }}>
        {seniorCareSteps ? (
          <>
            {seniorCareIndividualSmb.map(({ Icon, ...item }) => (
              <Chip
                key={item.label}
                icon={<Icon size="48px" color={theme.palette?.care?.grey[900]} />}
                label={item.label}
                variant="outlined"
                onClick={() => handleSeniorCareSitter(item.label, item.redirectUrl)}
                sx={() => ({
                  width: '100%',
                  height: '78px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  paddingLeft: 3,
                  marginBottom: '8px',
                  fontSize: '18px',
                  '& .MuiSvgIcon-root': {
                    marginRight: '8px',
                  },
                  '&:active, &.default': {
                    backgroundColor: `${theme.palette.secondaryButton.lighter} !important`,
                    border: theme.palette.secondaryButton.lighter,
                    boxShadow: 'none',
                  },
                })}
              />
            ))}
          </>
        ) : (
          <Grid
            container
            direction="row"
            display="flex"
            margin="0 auto"
            justifyContent="space-between">
            <Button
              color="primary"
              variant="contained"
              data-testid="findACaregiver"
              sx={{ maxWidth: '160px' }}
              onClick={handleDTSeeker}>
              {modalButtonsText.seeker}
            </Button>
            <Button
              color="primary"
              variant="contained"
              data-testid="findAJob"
              sx={{ maxWidth: '160px' }}
              onClick={handleDTSitter}>
              {modalButtonsText.provider}
            </Button>
          </Grid>
        )}
      </Box>
    </Modal>
  );
}

export default GreaterCareModalMemberSelection;
